// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__i86FU","footer":"ModalInfo_footer__33BtN"};